"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _propTypes = _interopRequireWildcard(require("prop-types"));

var _typography = _interopRequireDefault(require("../typography"));

var _button = _interopRequireDefault(require("../button"));

var _fi = require("react-icons/fi");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.modal-container {\n  display: flex;\n  flex-direction: column;\n  border: 0.0625rem solid #6f6f6f;\n  box-sizing: border-box;\n  opacity: 1;\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 100%;\n  min-width: 29rem;\n  background-color: #ffffff;\n  z-index: 30; }\n  .modal-container .modal-strap {\n    min-height: 0.5rem;\n    min-width: 28.875rem;\n    background-color: #067fdb; }\n  .modal-container .heading-container {\n    display: flex;\n    justify-content: space-between; }\n    .modal-container .heading-container .title-container {\n      margin-left: 2rem;\n      margin-top: 2rem;\n      margin-bottom: 1.5rem;\n      color: #393939; }\n    .modal-container .heading-container .icon-container {\n      margin-right: 2rem;\n      margin-top: 2.4375rem;\n      margin-bottom: 1.5rem;\n      height: 1.5rem; }\n      .modal-container .heading-container .icon-container .icon {\n        cursor: pointer;\n        color: #393939; }\n  .modal-container .buttons-container {\n    display: flex;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    margin-left: 2rem;\n    margin-right: 2rem;\n    gap: 0.0625rem; }\n    .modal-container .buttons-container .button-wrapper {\n      margin-right: 1rem;\n      margin-bottom: 1rem; }\n  .modal-container .content-separator {\n    width: 100%;\n    margin: 0; }\n  .modal-container .modal-children-container {\n    overflow: auto;\n    height: 100%; }\n    .modal-container .modal-children-container .modal-children {\n      margin: 2rem; }\n\n.modal-overlay-container {\n  position: fixed;\n  background-color: #161616;\n  opacity: 0.3;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 20; }\n";
  var fileName = "compone_popup";
  var element = document.querySelector("style[data-sass-component='compone_popup']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var ModalPopup = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var width = _ref.width,
      title = _ref.title,
      buttons = _ref.buttons,
      onCancel = _ref.onCancel,
      children = _ref.children,
      classNamePrefix = _ref.classNamePrefix;

  var _useState = (0, _react.useState)(document.createElement('div')),
      _useState2 = _slicedToArray(_useState, 1),
      modalEl = _useState2[0];

  modalEl.id = _constants.modalPopupId;
  modalEl.style.zIndex = 100;

  if (classNamePrefix) {
    modalEl.className = "".concat(classNamePrefix, "-").concat(_constants.modalPopupId);
  }

  (0, _react.useEffect)(function () {
    var bodyElement = document.getElementsByTagName('body')[0];
    bodyElement.appendChild(modalEl);
    return function () {
      return bodyElement.removeChild(modalEl);
    };
  }, [modalEl]);

  var getClassNames = function getClassNames(elementClassName) {
    var finalClassName = elementClassName;

    if (classNamePrefix) {
      finalClassName += " ".concat(classNamePrefix, "-").concat(elementClassName);
    }

    return finalClassName;
  };

  var getModalStrap = function getModalStrap() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: getClassNames(_constants.classes.modalStrap),
      style: {
        width: width - 2
      }
    });
  };

  var crossIconKeyDownHandler = function crossIconKeyDownHandler(event) {
    if (event.code === _constants.enterCode) {
      onCancel();
    }
  };

  var getModalHeader = function getModalHeader() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: getClassNames(_constants.classes.headingContainer)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: getClassNames(_constants.classes.titleContainer)
    }, /*#__PURE__*/_react.default.createElement(_typography.default, {
      variant: "heading4"
    }, title)), /*#__PURE__*/_react.default.createElement("div", {
      className: getClassNames(_constants.classes.iconContainer)
    }, /*#__PURE__*/_react.default.createElement(_fi.FiX, {
      tabIndex: 0,
      size: _constants.iconSize,
      onClick: onCancel,
      onKeyDown: crossIconKeyDownHandler,
      className: getClassNames(_constants.classes.icon),
      role: _constants.crossIconRole
    })));
  };

  var getActionButtons = function getActionButtons() {
    return buttons && /*#__PURE__*/_react.default.createElement("div", {
      className: getClassNames(_constants.classes.buttonsContainer)
    }, buttons.map(function (item, index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: "".concat(_constants.buttonWrapperPrefix).concat(index),
        className: getClassNames(_constants.classes.buttonWrapper)
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        variant: item.variant,
        size: item.size,
        onClick: item.onClick,
        disabled: item === null || item === void 0 ? void 0 : item.disabled,
        leftSVGIcon: item === null || item === void 0 ? void 0 : item.leftSVGIcon,
        rightSVGIcon: item === null || item === void 0 ? void 0 : item.rightSVGIcon
      }, item.text));
    }));
  };

  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: getClassNames(_constants.classes.overlayContainer)
  }), /*#__PURE__*/_react.default.createElement("div", {
    role: _constants.modalPopupRole,
    className: getClassNames(_constants.classes.modalContainer),
    style: {
      width: width
    }
  }, getModalStrap(), getModalHeader(), getActionButtons(), /*#__PURE__*/_react.default.createElement("hr", {
    className: getClassNames(_constants.classes.contentSeparator)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: getClassNames(_constants.classes.modalChildrenContainer),
    ref: ref
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: getClassNames(_constants.classes.modalChildren)
  }, children)))), modalEl);
});

ModalPopup.propTypes = {
  width: _propTypes.default.number,
  title: _propTypes.default.string.isRequired,
  buttons: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string.isRequired,
    variant: _propTypes.default.string,
    size: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func.isRequired
  })),
  onCancel: _propTypes.default.func.isRequired,
  classNamePrefix: _propTypes.default.string
};
var _default = ModalPopup;
exports.default = _default;